export const NAMESPACE = 'semanticArticles';
